module.exports = __webpack_public_path__ + "static/img/6.cf922ff.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/upcash/6.png
// module id = Y68C
// module chunks = 5